<template>
  <v-card>
    <div class="header">
      <div class="d-flex align-center justify-space-between">
        <h2>Detail Permintaan Pemeriksaan Laboratorium</h2>
        <v-btn text fab small dense depressed @click="$emit('close-dialog')"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>
      <div class="d-flex align-center mt-1">
        <p>No RM</p>
        <p>{{ patientData.rmNumber }}</p>
        <p>Nama</p>
        <p>{{ patientData.name }} ({{ patientData.gender ? 'L' : 'P' }})</p>
        <p>Tanggal Lahir</p>
        <p>{{ patientData.birthDate }} ({{ patientData.age }})</p>
        <p>Unit</p>
        <p>{{ patientData.unit }}</p>
      </div>
    </div>
    <v-divider />
    <div class="main">
      <v-tabs grow centered v-model="tab">
        <v-tab class="text-capitalize" style="letter-spacing: .1px;"
          >Detail Permintaan</v-tab
        >
        <v-tab
          :disabled="!patientData.isInputed"
          class="text-capitalize"
          style="letter-spacing: .1px;"
          >Hasil Pemeriksaan</v-tab
        >
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <detail-examination-tab
            ref="update"
            is-from-history
            :status-order="patientData.status"
          />
        </v-tab-item>
        <v-tab-item>
          <result-examination-tab stateResult="request" fromHistory />
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div class="d-flex justify-end align-center py-4 px-15">
      <template v-if="patientData.status.text === 'belum diproses'">
        <v-btn
          @click="$emit('close-dialog')"
          class="text-capitalize mr-3"
          style="letter-spacing: .01px;"
          color="primary"
          text
          dense
          single-line
          >Batal</v-btn
        >
        <v-btn
          @click="handleUpdateLabRequest"
          class="text-capitalize"
          depressed
          dense
          single-line
          :disabled="!getIsChanged"
          style="letter-spacing: .01px;"
          color="primary"
          >Simpan Perubahan</v-btn
        >
      </template>
      <template
        v-if="
          patientData.status.text !== 'belum diproses' && !patientData.isInputed
        "
      >
        <v-btn
          @click="$emit('close-dialog')"
          class="text-capitalize"
          depressed
          dense
          single-line
          style="letter-spacing: .01px;"
          color="primary"
          >Kembali</v-btn
        >
      </template>
      <template
        v-if="
          patientData.status.text !== 'belum diproses' && patientData.isInputed
        "
      >
        <v-btn
          @click="$emit('close-dialog')"
          class="text-capitalize mr-3"
          depressed
          dense
          outlined
          single-line
          style="letter-spacing: .01px;"
          color="primary"
          >Kembali</v-btn
        >
        <!-- @click="$emit('close-dialog')" -->
        <v-btn
          class="text-capitalize"
          depressed
          dense
          single-line
          @click="printOrder"
          style="letter-spacing: .01px;"
          color="primary"
          ><v-icon class="mr-2">mdi-printer</v-icon> Print Hasil</v-btn
        >
      </template>
    </div>
  </v-card>
</template>

<script>
import DetailExaminationTab from './DetailExaminationTab.vue';
import ResultExaminationTab from './ResultExaminationTab.vue';
import { createNamespacedHelpers } from 'vuex';
import printLaboratoryResult from '@/mixin/printLaboratoryResult.js';
import printMixin from '@/mixin/printMixin';
import formatMixin from '@/mixin/formatMixin';
const moment = require('moment-timezone');

const {
  mapGetters: labGetters,
  mapActions: labActions,
  mapMutations: labMutations,
} = createNamespacedHelpers('ExaminationLaboratory');

export default {
  name: 'DetailAndResultLabOrder',
  mixins: [printLaboratoryResult, printMixin, formatMixin],
  props: {
    patientData: Object,
  },
  components: {
    DetailExaminationTab,
    ResultExaminationTab,
  },
  beforeDestroy() {
    this.clearState();
  },
  methods: {
    ...labMutations(['clearState']),
    ...labActions(['resolveUpdateLabRequest', 'resolveGetLabResult']),
    async handleUpdateLabRequest() {
      if (this.$refs.update.$refs.form.validate()) {
        await this.resolveUpdateLabRequest();
        this.$emit('close-dialog');
      }
    },
    async printOrder() {
      try {
        if (!this.patientData.isInputed) return;
        if (!this.getLabResultById.patient) {
          await this.resolveGetLabResult();
        }
        const doc = this.printLabResult({
          doctor: this.getLabResultById.staff?.name,
          timeOrder: moment(this.getLabResultById.timestamps.created_at).format(
            'DD-MM-YYYY',
          ),
          timeFinish: moment(
            this.getLabResultById.timestamps.finished_at,
          ).format('DD-MM-YYYY'),
          name: this.getLabResultById.patient.name,
          address: this.formatAddress(this.getLabResultById.patient.address),
          guarantorType: this.getLabResultById.assurance,
          gender: this.getLabResultById.patient.gender
            ? 'Laki-laki'
            : 'Perempuan',
          birthDateAge: `${this.patientData.birthDate} (${this.patientData.age} Tahun)`,
          noLabRM: this.getLabResultById.patient.medical_record_number,
          testItem: this.getLabResultById.test_item,
          clinicalNotes: this.getLabResultById.clinical_notes,
          recommendation: this.getLabResultById.recommendation,
          timestamps: this.getLabResultById.timestamps,
          staff_request: this.getLabResultById.staff_request?.name,
        });
        this.printDocument(doc, {
          docName: 'Hasil Laboratorium',
          rmNumber: this.getLabResultById.patient.medical_record_number,
        });
      } catch (error) {
        return error;
      }
    },
  },
  computed: {
    ...labGetters(['getIsChanged', 'getLabResultById', 'getPatientData']),
  },
  data() {
    return {
      tab: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.v-card {
  width: 80vw;

  .main {
    padding: 0.3vw 1.7vw 0 1.7vw;
  }

  .header {
    padding: 0.8vw 1.7vw 0 1.7vw;

    h2 {
      font-size: 1.1vw;
      text-align: left;
    }
    p:nth-of-type(even) {
      margin-right: 2rem;
    }
    p:nth-of-type(odd) {
      margin-right: 1.8rem;
      color: #9e9e9e;
    }
  }
}
</style>
